/*! MFAC collection auto infinite scroll — Lance tap 2026-09-17
 * Appends next page product cards on scroll. Hides classic Next UX.
 * Works with Impulse CollectionAjaxContent after filter replacements.
 */
(function () {
  'use strict';

  var LOADING = false;

  function productGrid(root) {
    return root && root.querySelector('.product-grid-container');
  }

  function nextLink(root) {
    var a = root && root.querySelector('.pagination .next a');
    return a ? a.getAttribute('href') : null;
  }

  function setStatus(el, text, show) {
    if (!el) return;
    if (text) el.textContent = text;
    if (show) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  function reinitThemeBits(container) {
    try {
      if (window.theme && theme.LibraryLoader) {
        // no-op if unavailable
      }
      document.dispatchEvent(new CustomEvent('collection:reloaded'));
      if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) {
        // ignore
      }
      // Re-run product grid lazy/images if theme exposes helpers
      if (window.theme && theme.collapsibles) {
        // leave
      }
      var imgs = container.querySelectorAll('img[loading="lazy"]');
      // browsers handle lazy
      void imgs;
    } catch (e) {}
  }

  function appendPage(html, mount) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var incomingAjax = doc.querySelector('#CollectionAjaxContent') || doc;
    var incomingGrid = productGrid(incomingAjax);
    var liveGrid = productGrid(document.getElementById('CollectionAjaxContent') || document);
    if (!incomingGrid || !liveGrid) return { ok: false, next: null };

    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(incomingGrid.children, function (child) {
      // skip empty placeholders
      frag.appendChild(child.cloneNode(true));
    });
    liveGrid.appendChild(frag);

    var next = nextLink(incomingAjax);
    var infinite = mount;
    if (infinite) {
      if (next) infinite.setAttribute('data-next-url', next);
      else {
        infinite.removeAttribute('data-next-url');
        infinite.setAttribute('data-complete', 'true');
      }
    }
    reinitThemeBits(liveGrid);
    return { ok: true, next: next };
  }

  async function loadNext(mount) {
    if (LOADING) return;
    var url = mount.getAttribute('data-next-url');
    if (!url || mount.getAttribute('data-complete') === 'true') return;
    LOADING = true;
    var status = mount.querySelector('[data-mfac-infinite-status]');
    setStatus(status, 'Loading more artwork…', true);
    try {
      var res = await fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var html = await res.text();
      var result = appendPage(html, mount);
      if (!result.next) setStatus(status, '', false);
    } catch (err) {
      setStatus(status, 'Could not load more. Scroll again or refresh.', true);
      console.warn('[mfac-infinite]', err);
    } finally {
      LOADING = false;
    }
  }

  function bind(mount) {
    if (!mount || mount.__mfacInfiniteBound) return;
    mount.__mfacInfiniteBound = true;
    var sentinel = mount.querySelector('[data-mfac-infinite-sentinel]') || mount;
    if (!('IntersectionObserver' in window)) {
      // Fallback: load on scroll near bottom
      window.addEventListener(
        'scroll',
        function () {
          if (LOADING) return;
          var rect = sentinel.getBoundingClientRect();
          if (rect.top < window.innerHeight + 600) loadNext(mount);
        },
        { passive: true }
      );
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext(mount);
        });
      },
      { root: null, rootMargin: '800px 0px', threshold: 0 }
    );
    io.observe(sentinel);
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-mfac-infinite]').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });

  // After Impulse filter/sort ajax replaces CollectionAjaxContent
  document.addEventListener('theme:collection:loaded', function () {
    boot(document);
  });
  // MutationObserver: when CollectionAjaxContent is replaced
  var ajax = document.getElementById('CollectionAjaxResult');
  if (ajax && 'MutationObserver' in window) {
    new MutationObserver(function () {
      boot(document);
    }).observe(ajax, { childList: true, subtree: false });
  }
})();
